import { inputBaseClasses } from '@mui/material/InputBase'
import { Theme } from '@mui/material/styles'
export const styles = {
  form: {
    fontSize: '14px',
    padding: (theme: Theme) =>
      `${theme.spacing(2)} 0 ${theme.spacing(2)} ${theme.spacing(2)}`,
  },

  section: {
    marginBottom: (theme: Theme) => theme.spacing(3),
    display: 'flex',
    flexDirection: 'column',
  },

  sectionHeader: {
    display: 'flex',
    alignItems: 'baseline',
    paddingRight: (theme: Theme) => theme.spacing(2),
  },

  sectionLabel: {
    fontFamily: 'Source Sans Pro Bold',
    marginRight: 'auto',
  },

  row: {
    display: 'flex',
    alignItems: 'center',
    padding: (theme: Theme) =>
      `${theme.spacing(1)} ${theme.spacing(2)} ${theme.spacing(1)} 0`,
  },

  subSection: {
    fontSize: '12px',
    margin: (theme: Theme) =>
      `${theme.spacing(-1)} ${theme.spacing(2)} 0 ${theme.spacing(7.8)}`,
    padding: (theme: Theme) =>
      `${theme.spacing(0.7)} ${theme.spacing(0)} ${theme.spacing(
        0.7,
      )} ${theme.spacing(2.5)}`,
    backgroundColor: '#f7f7f7',
    border: '1px solid #c4c4c4',
    borderTop: 'none',
    borderRadius: '0 0 4px 4px',
  },

  textField: { width: '100%' },

  textFieldSquare: {
    [`& .${inputBaseClasses.root}.${inputBaseClasses.disabled}`]: {
      '& fieldset': {
        borderRadius: '4px 4px 0 0',
      },
    },
  },

  actionContainer: {
    display: 'flex',
    alignItems: 'center',
    margin: (theme: Theme) => `${theme.spacing(0.4)} 0 auto 0`,
  },

  lockIcon: { margin: (theme: Theme) => `0 ${theme.spacing(1.9)}` },
  deleteButton: { margin: (theme: Theme) => `0 ${theme.spacing(1.6)}` },
  smallLockIcon: {
    margin: (theme: Theme) => `0 ${theme.spacing(1.4)} 0 ${theme.spacing(0.3)}`,
  },
  smallDeleteButton: {
    margin: (theme: Theme) => `0 ${theme.spacing(1.1)} 0 0`,
  },
  smallButton: { fontSize: '12px' },
  draggable: { backgroundColor: (theme: Theme) => theme.palette.common.white },
  checkboxRoot: { margin: 0 },
  checkboxLabel: { fontSize: '14px' },
  checkboxSubRoot: { marginLeft: (theme: Theme) => theme.spacing(2.5) },
  checkboxNestedSubRoot: { marginLeft: (theme: Theme) => theme.spacing(5) },
  loadingContainer: { display: 'flex' },
  loader: { margin: 'auto' },
  editAlert: {
    margin: (theme: Theme) => `0 ${theme.spacing(2)} ${theme.spacing(1)} 0`,
  },
}
